import style from "./style.module.scss";
import icon from "../../../img/modals/like.svg";
import {useStore} from "effector-react";
import {$store} from "../../../store";

const PlsBetB = (props:{onBet:Function,onCancel:Function}) => {

	const store = useStore($store);

	return (
		<div className={style.plsBetB}>
			<div className={style.icon}>
				<img src={icon} alt=""/>
			</div>
			<p className={style.title}>Ваш прогноз принят!</p>
			<p className={style.subtitle}>Для выполнения всех условий акции вам необходимо сделать любую ставку на спорт.</p>
			<div className={style.buttons}>
				<div onClick={()=>{ props.onBet(); }} className={`${style.btn} ${style.btnA}`}>Сделать ставку</div>
				<div onClick={()=>{ props.onCancel(); }} className={`${style.btn} ${style.btnB}`}>Позже</div>
			</div>
		</div>
	);
};

export default PlsBetB;
